var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"flymojis"},[_vm._l((_vm.flymojis),function(flymoji){return [_c('li',{key:flymoji.id,domProps:{"innerHTML":_vm._s(flymoji.svg)}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }